import MainHeader from "components/Header/MainHeader";
import React from "react";
import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ResearchComparatorSection from "./components/ResearchComparatorSection";
import AnalysisDashboardSection from "./components/AnalysisDashboardSection";
import AdOrganizerSection from "./components/AdOrganizerSection";
import PartnarsSection from "./components/PartnarsSection";
import SignInFeeSection from "./components/SignInFeeSection";
import Footer from "components/Footer/Footer";
import FindOutSection from "./components/FindOutSection";
import WhatTheySayAboutUsSection from "./components/WhatTheySayAboutUsSection";
import AppLayout from "components/Layout/AppLayout";

const Home = () => {
  return (
    <AppLayout isSearchVisable={false}>
      <HeroSection />
      <HowItWorksSection />
      <ResearchComparatorSection />
      <AdOrganizerSection />
      <AnalysisDashboardSection />
      <PartnarsSection />
      <SignInFeeSection />
      <WhatTheySayAboutUsSection />
      <FindOutSection />
      <Footer />
    </AppLayout>
  );
};

export default Home;
